"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EventId = void 0;
var EventId;
(function (EventId) {
    EventId[EventId["LOAD_PHASE_START"] = 28] = "LOAD_PHASE_START";
    EventId[EventId["LOAD_PHASE_FINISH"] = 22] = "LOAD_PHASE_FINISH";
    EventId[EventId["INTERACTION_START"] = 24] = "INTERACTION_START";
    EventId[EventId["INTERACTION_END"] = 25] = "INTERACTION_END";
    EventId[EventId["ERROR"] = 26] = "ERROR";
})(EventId = exports.EventId || (exports.EventId = {}));
//# sourceMappingURL=renderer.js.map